/**
 * Mandatory disclaimer text.
 *
 * DRAFT — reviewed by no lawyer. The product owner must obtain their own legal
 * review before launch. This is not legal advice.
 *
 * The independence disclaimer is a hard requirement, not a nicety: APC states it
 * does not endorse third-party preparation programs, and CAOP and OPRA are
 * registered trademarks. This string must remain visible in the site footer and
 * on the signup screen.
 */
export const INDEPENDENCE_DISCLAIMER = 'Titrate is an independent study aid. It is not affiliated with, endorsed by, sponsored by or connected to the Australian Pharmacy Council (APC) in any way. CAOP® and OPRA® are registered trademarks of the Australian Pharmacy Council. All practice questions are original content written for this platform; no real exam material is reproduced.';
export const SHORT_DISCLAIMER = 'Independent study aid — not affiliated with or endorsed by the Australian Pharmacy Council. CAOP® and OPRA® are APC trademarks.';
/**
 * Attached to every benchmark and feedback report. The real exams are reported
 * pass/fail against a scaled psychometric standard; candidates never see a raw
 * score, so any percentage we show is a study signal, not a prediction.
 */
export const PRACTICE_PROXY_NOTICE = 'This is a practice proxy, not an official predictor. The real APC exams are reported as pass/fail against a scaled psychometric standard — candidates never receive a raw score, and no third-party score can be mapped to that standard. Use these results to find and close knowledge gaps, not to estimate your likelihood of passing.';
/**
 * Shown wherever CAOP book-reliance is reported. We cannot proctor reference use,
 * so we must be explicit that this metric is self-reported and approximate.
 */
export const BOOK_USE_APPROXIMATION_NOTICE = 'Reference use is self-reported and combined with a response-time signal. It is an approximation to help you notice over-reliance on your books — it is not a proctored measurement, and it is not how the real exam is assessed.';
//# sourceMappingURL=legal.js.map